"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNegativeZero = void 0;
exports.isNegativeZero = (value) => Object.is(value, -0);
//# sourceMappingURL=is-negative-zero.js.map